
import { RSVPButton } from "@/components/ui/rsvp-button";
import { Button } from "@/components/ui/button";
import { Send, Calendar, Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface ShareEventButtonProps {
  onClick: () => void;
  variant?: "primary" | "secondary";
  buttonType?: "invite" | "confirm";
  className?: string;
}

export const ShareEventButton = ({
  onClick,
  variant = "primary",
  buttonType = "invite",
  className
}: ShareEventButtonProps) => {
  // Get the appropriate icon and text based on buttonType
  const getIconAndText = () => {
    if (buttonType === "invite") {
      return {
        icon: <Send className="h-5 w-5" />,
        text: "Send Invites"
      };
    } else {
      return {
        icon: <Calendar className="h-5 w-5" />,
        text: "Confirm Details"
      };
    }
  };
  
  const { icon, text } = getIconAndText();
  
  // Use RSVPButton for primary variant, regular Button for secondary
  if (variant === "primary") {
    return (
      <RSVPButton 
        onClick={onClick} 
        className={cn("px-3 inline-flex items-center justify-center gap-2 transform transition-transform duration-150 self-center", className)}
      >
        {icon}
        {text}
      </RSVPButton>
    );
  }
  
  return (
    <Button 
      variant="outline"
      onClick={onClick} 
      className={cn("px-3 inline-flex items-center justify-center gap-2 transform transition-transform duration-150 self-center", className)}
    >
      {icon}
      {text}
    </Button>
  );
};
